import { APIURL } from './../constant'
import http from './../interceptors/http-interceptor'
/* @purpose: check login.
@params: user_id, password
  @response: return login response.
  */
export function login(user_id, password) {
  return http.post(`${APIURL}/login`, { user_id, password })
}
